

import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';
import ManageShopCategoryIcon from '../../../components/SiteAdmin/ShopCategoryIcon/ManageShopCategoryIcon';

function action(props) {
  const { store, intl } = props;
  const title = 'Manage Shop Category Icon';

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  // if (!restrictUrls('/siteadmin/shop-category-icon', adminPrivileges, privileges)) {
  //   return { redirect: '/siteadmin' };
  // }

  return {
    title,
    component: (
      <AdminLayout>
        <ManageShopCategoryIcon {...props} />
      </AdminLayout>
    ),
  };
}

export default action; 